import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import CorporateGroupDetails from '../../components/CorporateGroupDetails/CorporateGroupDetails'
import Footer from '../../components/Footer'
import Header from '../../components/Header'

const CorporateGroupDetailsPage = () => {
    return (
        <>
            <Helmet>
                <title>Group Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <CorporateGroupDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default CorporateGroupDetailsPage